export const cellDataUpdated = 'CELL_DATA_UPDATED';
export const cellSelected = 'CELL_SELECTED';
export const cellUnselected = 'CELL_UNSELECTED';

export default {
    updated: cellDataUpdated,
    selected: cellSelected,
    unselected: cellUnselected
};
